// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "prices-carousel")
// Template updated: templates/public/static/ads/main-content.html.twig (data-lazy-init="slick-slider")

import $ from "jquery";

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

$(document).ready(function(){
    // Wheel-scroll navigation (page-specific UX — guard ensures slick is initialized first)
    $('.prices-carousel').on('wheel', function(e) {
        if (!$(this).hasClass('slick-initialized')) return;
        e.preventDefault();
        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    });

    if ($('.prices-carousel-wrapper').length) {
        $(".prev-btn").click(function () {
            var $carousel = $(".prices-carousel");
            if (!$carousel.hasClass('slick-initialized')) return;
            $carousel.slick("slickPrev");
        });

        $(".next-btn").click(function () {
            var $carousel = $(".prices-carousel");
            if (!$carousel.hasClass('slick-initialized')) return;
            $carousel.slick("slickNext");
        });

        $(".prev-btn").addClass("slick-disabled");

        $(".prices-carousel").on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
                $(".prev-btn").addClass("slick-disabled");
            } else {
                $(".prev-btn").removeClass("slick-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
                $(".next-btn").addClass("slick-disabled");
            } else {
                $(".next-btn").removeClass("slick-disabled");
            }
        });
    }
});

